<template>
  <div class="update-post-modal">
    <modal name="update-post-modal"
           :click-to-close="false"
           width="750px"
           height="auto"
           class="select-group-modal modal-custom"
           transition="easeInOut"
           @before-open="beforeOpened"
           @before-close="beforeClosed"
    >
      <vue-element-loading :active="show" spinner="bar-fade-scale"/>
      <div v-if="!isEditingMedia && !isTagUser">
        <md-card class="modal-header-custom">
          <template>
            <md-dialog-title>
              <span class="neutral_1 heading-500 text-header-modal">Chỉnh sửa bài viết</span>
              <span class="material-icons float-right cursor-pointer"
                    @click="$modal.hide('update-post-modal')">close</span>
            </md-dialog-title>
          </template>
        </md-card>

        <md-card-content>
          <md-list class="nav p-0px">
            <template>
              <md-list-item class="pt-0px user-group-info">
                <md-avatar>
                  <img class="avatar" :src="userInfo.avatar_url?userInfo.avatar_url:'/img/profile/avatar.png'">
                </md-avatar>
                <div class="md-list-item-text">
                  <span>
                    <span class="cursor-pointer text-400-semibold">{{ userInfo.fullname }}</span>
                      <span class="cursor-pointer" v-if="tagUserItems.length > 0">
                        <span class="text-400-default"> cùng với </span>
                        <span class="cursor-pointer text-400-semibold"
                              @click="changeToTagUserPopup('to_tag_user')">{{ tagUserItems[0].fullname }}</span>
                        <span v-if="tagUserItems[1]">
                          <span class="text-400-default">, </span>
                          <span class="cursor-pointer text-400-semibold"
                                @click="changeToTagUserPopup('to_tag_user')">{{ tagUserItems[1].fullname }}</span>
                        </span>
                        <span v-if="tagUserItems.length > 2">
                          <span class="text-400-default"> và </span>
                          <span class="cursor-pointer text-400-semibold"
                                @click="changeToTagUserPopup('to_tag_user')">{{
                              tagUserItems.length - 2
                            }} người khác</span>
                        </span>
                    </span>
                  </span>
                  <p class="neutral_2 text-300-default mt-3 group-text">
                    <span v-if="groupInfo.length === 0">Tường cá nhân</span>
                    <span v-else>
                     <img class="bookmark" src="/img/modal/people.svg">
                     {{ groupInfo.name }} - {{ groupInfo.member_count }} thành viên</span>
                  </p>
                </div>
              </md-list-item>
              <div style="max-height: 700px; overflow-y: auto;">
                <div class="post-has-background__wrapper" v-if="postBackground && hasAllowedBackground"
                     :style="'background-image: url(' + postBackground.background_url + ')'">
                  <div class="post-has-background-input__wrapper">
                    <div class="post-has-background-input__main p-relative">
                      <div class="post-has-background-input__title" v-if="html_content === ''">Bạn đang nghĩ gì?</div>
                      <div-editable v-model="html_content" :style="{'color': postBackground.color}"/>
                    </div>
                  </div>
                </div>
                <div class="p-relative" v-else>
                  <ckeditor v-model="html_content" :config="editorConfig">
                  </ckeditor>
                  <img class="img-emoji" src="/img/post/footer/smile.png" @click="toogleDialogEmoji">
                  <VEmojiPicker class="p-absolute emoji" v-if="showDialogEmoji" @select="onSelectEmoji"
                                v-click-outside="hiddenDialogEmoji"/>
                </div>
                <div class="md-layout mt-15px p-relative">
                  <div class="background-list__wrapper" v-if="canShowBackgroundList">
                    <div class="background-item background_neutral_white" @click="postBackground = null"></div>
                    <div class="background-item" :style="'background-image: url(' + item.thumbnail.small_thumb + ')'"
                         v-for="(item, index) in postBackgroundImageList.slice(0, 12)"
                         :key="'background-item' + index"
                         :class="{active: postBackground != null && postBackground.background_url === item.path}"
                         @click="selectPostBackground({'background_url': item.path, 'color': item.color})">
                    </div>
                    <div class="background-item" @click="isSelectingBackground = true">
                      <md-icon>apps</md-icon>
                    </div>
                  </div>
                  <div class="upload-btn-wrapper mr-15px"
                       v-if="!disableBackgroundBtn && pollData == null">
                    <button class="btn btn-background cursor-pointer" v-popover:tooltip.top="'Chọn ảnh nền'"
                            @click="canShowBackgroundList = !canShowBackgroundList">
                      <md-icon v-if="canShowBackgroundList">expand_less</md-icon>
                      <i class="md-icon md-icon-font md-theme-default background" v-else></i>
                    </button>
                  </div>
                  <div class="upload-btn-wrapper mr-15px">
                    <button class="btn btn-image cursor-pointer"
                            :class="{'active': isActiveImageBtn, 'disabled': hasDisabledImageBtn}"
                            v-popover:tooltip.top="'Thêm ảnh/video'">
                      <div class="btn-icon image cursor-pointer"></div>
                      <input type="file" class="custom-input cursor-pointer" name="files" multiple
                             :disabled="hasDisabledImageBtn"
                             @click="selectUpload(POST_TYPE.IMAGE)"
                             @change="onFileChange"
                             accept="image/*,video/mp4,video/avi">
                    </button>
                  </div>
                  <div class="upload-btn-wrapper mr-15px" v-popover:tooltip.top="'Thêm file'">
                    <button class="btn btn-file cursor-pointer"
                            :class="{'active': isActiveFileBtn, 'disabled': hasDisabledFileBtn}">
                      <div class="btn-icon file cursor-pointer"></div>
                      <input type="file" class="custom-input cursor-pointer"
                             :disabled="hasDisabledFileBtn"
                             @click="selectUpload(POST_TYPE.FILE)"
                             name="files"
                             @change="onFileChange"
                             multiple
                             accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf">
                    </button>
                  </div>
                  <div class="upload-btn-wrapper" v-popover:tooltip.top="'Gắn thẻ đồng nghiệp'"
                       @click="changeToTagUserPopup('to_tag_user')">
                    <button class="btn poll-btn cursor-pointer" :class="{'active': this.isTagUser}">
                      <md-icon>sell</md-icon>
                    </button>
                  </div>
                </div>

                <poll-content v-if="pollData != null" :poll-data="pollData" :is-update-post-modal="true"/>
                <div class="post-layout">
                  <div class="post-content">
                    <vue-element-loading :active="loadingUploadFile" spinner="bar-fade-scale"/>
                    <md-card-content>
                      <div class="image-content" @click="editImageContent"
                           v-if="selectTypeUpload && (selectTypeUpload === POST_TYPE.IMAGE || selectTypeUpload === POST_TYPE.ALBUM)">
                        <button class="edit-img-btn">
                          <svg width="16" height="17" viewBox="0 0 16 17" fill="none"
                               xmlns="http://www.w3.org/2000/svg" class="mr-2">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M10.6462 1.31222C10.8415 1.11696 11.1581 1.11696 11.3534 1.31222L11.8819 1.84081C11.947 1.9059 12.0526 1.9059 12.1176 1.84081L12.6462 1.31222C12.8415 1.11696 13.1581 1.11696 13.3534 1.31222C13.5486 1.50748 13.5486 1.82406 13.3533 2.01932L12.8248 2.54792C12.7597 2.61301 12.7597 2.71854 12.8248 2.78362L13.3533 3.31222C13.5486 3.50748 13.5486 3.82406 13.3533 4.01933C13.1581 4.21459 12.8415 4.21459 12.6462 4.01932L12.1176 3.49073C12.0526 3.42564 11.947 3.42564 11.8819 3.49073L11.3533 4.01932C11.1581 4.21459 10.8415 4.21459 10.6462 4.01932C10.451 3.82406 10.451 3.50748 10.6462 3.31222L11.1748 2.78362C11.2399 2.71854 11.2399 2.61301 11.1748 2.54792L10.6462 2.01932C10.451 1.82406 10.451 1.50748 10.6462 1.31222ZM6.4998 1.91845C6.4998 1.64231 6.27594 1.41845 5.9998 1.41845C5.72365 1.41845 5.4998 1.64231 5.4998 1.91845V2.666C5.4998 2.75805 5.42518 2.83266 5.33313 2.83266L4.58558 2.83266C4.30944 2.83266 4.08558 3.05652 4.08558 3.33266C4.08558 3.60881 4.30944 3.83266 4.58558 3.83266L5.33313 3.83266C5.42518 3.83266 5.4998 3.90728 5.4998 3.99933V4.74688C5.4998 5.02302 5.72365 5.24688 5.9998 5.24688C6.27594 5.24688 6.4998 5.02302 6.4998 4.74688V3.99933C6.4998 3.90728 6.57442 3.83266 6.66646 3.83266H7.41401C7.69015 3.83266 7.91401 3.60881 7.91401 3.33266C7.91401 3.05652 7.69015 2.83266 7.41401 2.83266H6.66646C6.57442 2.83266 6.4998 2.75805 6.4998 2.666V1.91845ZM11.057 5.72276L10.9426 5.60838C10.4219 5.08768 9.57769 5.08768 9.05699 5.60838L8.13787 6.5275L10.1379 8.5275L11.057 7.60838C11.5777 7.08768 11.5777 6.24346 11.057 5.72276ZM1.60927 13.0561L7.19506 7.47031L9.19506 9.47031L3.60927 15.0561C3.08857 15.5768 2.24436 15.5768 1.72366 15.0561L1.60927 14.9417C1.08858 14.421 1.08857 13.5768 1.60927 13.0561ZM13.8331 9.25178C13.8331 8.97564 13.6093 8.75178 13.3331 8.75178C13.057 8.75178 12.8331 8.97564 12.8331 9.25178V9.99933C12.8331 10.0914 12.7585 10.166 12.6665 10.166H11.9189C11.6428 10.166 11.4189 10.3899 11.4189 10.666C11.4189 10.9421 11.6428 11.166 11.9189 11.166H12.6665C12.7585 11.166 12.8331 11.2406 12.8331 11.3327V12.0802C12.8331 12.3564 13.057 12.5802 13.3331 12.5802C13.6093 12.5802 13.8331 12.3564 13.8331 12.0802V11.3327C13.8331 11.2406 13.9078 11.166 13.9998 11.166H14.7473C15.0235 11.166 15.2473 10.9421 15.2473 10.666C15.2473 10.3899 15.0235 10.166 14.7473 10.166H13.9998C13.9078 10.166 13.8331 10.0914 13.8331 9.99933V9.25178Z"
                                  fill="white"></path>
                          </svg>
                          <span class="ml-5px">Sửa</span>
                        </button>
                        <image-content
                            v-if="selectTypeUpload && (selectTypeUpload === POST_TYPE.IMAGE || selectTypeUpload === POST_TYPE.ALBUM)"
                            :mediaObject="{post_id: null, mediaList: medias, media_count: medias.length}"
                            :isPostModal="true">
                        </image-content>
                      </div>

                      <file-content v-if="selectTypeUpload && selectTypeUpload === POST_TYPE.FILE"
                                    :files=medias :is-modal="true"></file-content>
                    </md-card-content>
                  </div>
                </div>
              </div>
            </template>
          </md-list>
        </md-card-content>
        <md-dialog-actions class="update-modal-action">
          <button type="submit" class="btn-active md-button"
                  :class="{'disabled': (html_content === '' && medias.length == 0)}" @click="updatePost">Cập nhật
          </button>
          <button class="btn-stroke md-button" @click="$modal.hide('update-post-modal')">Huỷ</button>
        </md-dialog-actions>
      </div>
      <edit-media-modal v-if="isEditingMedia"
                        :mediaEditList="medias"
                        @cancel-editing-media="isEditingMedia = false"
                        @confirm-editing-media="confirmEditingMedia"
      />
      <tag-user-modal :group="groupInfo" :tag-user-items="tagUserItems" v-if="isTagUser"
                      @cancel-tag-user="isTagUser = false" @confirm-tag-user="handleTagUserForm"/>
      <select-post-background-modal v-if="isSelectingBackground"
                                    :background-image-list="postBackgroundImageList"
                                    :background-selected="postBackground"
                                    @cancel-selecting-background="isSelectingBackground = false"
                                    @select-post-background="selectPostBackground"/>
    </modal>
  </div>
</template>

<script>
import {POST_TYPE} from "../../../const/const";
import PostService from "../../../store/services/PostService";
import {VEmojiPicker} from 'v-emoji-picker';
import PollContent from "../Post/Content/PollContent";
import ImageContent from "../Post/Content/ImageContent";
import FileContent from "../Post/Content/FileContent";
import EditMediaModal from "./EditMediaModal";
import $ from "jquery";
import TagUserModal from "./TagUserModal";
import SettingService from "../../../store/services/SettingService";
import DivEditable from "./DivEditable";

export default {
  name: 'update-post-modal',
  components: {VEmojiPicker, PollContent, ImageContent, FileContent, EditMediaModal, TagUserModal, DivEditable},
  data() {
    return {
      postData: {},
      userInfo: {},
      groupInfo: {},
      html_content: '',
      POST_TYPE: POST_TYPE,
      medias: [],
      selectTypeUpload: null,
      files: [],
      show: false,
      showDialogEmoji: false,
      router_name: this.$route.name,
      editorConfig: {
        toolbar: [
          ['Source'],
          ['Styles', 'Format', 'Font', 'FontSize'],
          ['Bold', 'Italic'],
          ['Undo', 'Redo'],
          ['Link'],
          ['numberedList', 'bulletedList']
          // [ 'About' ]
        ]
      },
      isPoll: false,
      pollForm: null,
      pollData: null,
      loadingUploadFile: false,
      isEditingMedia: false,
      removedFileIds: [],
      isTagUser: false,
      tagUserItems: [],
      isSelectingBackground: false,
      postBackground: null,
      canShowBackgroundList: false,
      postBackgroundImageList: [],
      disableBackgroundBtn: false,
      hasAllowedBackground: false,
    }
  },
  computed: {
    isActiveImageBtn() {
      return this.selectTypeUpload &&
          (this.selectTypeUpload === POST_TYPE.IMAGE || this.selectTypeUpload === POST_TYPE.ALBUM || this.selectTypeUpload === POST_TYPE.VIDEO);
    },
    isActiveFileBtn() {
      return this.selectTypeUpload && this.selectTypeUpload === POST_TYPE.FILE;
    },
    hasDisabledImageBtn() {
      return this.pollData != null ||
          (this.selectTypeUpload && this.selectTypeUpload === POST_TYPE.FILE && this.medias.length > 0);
    },
    hasDisabledFileBtn() {
      return this.pollData != null ||
          (this.selectTypeUpload && (this.selectTypeUpload === POST_TYPE.IMAGE || this.selectTypeUpload === POST_TYPE.ALBUM) && this.medias.length > 0);
    }
  },
  created() {

  },
  mounted() {
    window.addEventListener("storage", this.storageListener);
  },
  destroyed() {
    window.removeEventListener("storage", this.storageListener);
  },
  methods: {
    beforeOpened(event) {
      this.getPostBackgroundImageList();
      this.file_ids = [];
      this.showDialogEmoji = false;
      this.removedFileIds = [];
      this.hasAllowedBackground = false;
      PostService.getPost({post_id: event.params.postData.id}).then(res => {
        if (res && res.data) {
          this.postData = res.data.post;
          this.userInfo = res.data.user;
          this.groupInfo = res.data.group;
          this.html_content = this.postData.html_content;
          this.selectTypeUpload = this.postData.type;
          this.medias = this.postData.medias;
          this.tagUserItems = [].concat(res.data.users_tagged);
          this.postBackground = this.postData.background;
          if (this.postData.background) {
            this.hasAllowedBackground = true;
          }
        }
      })
      this.pollData = event.params.pollData;
      if (this.pollData != null) {
        this.isPoll = true;
        this.pollForm.question = this.pollData.question;
        this.pollForm.is_add_option = this.pollData.is_add_option;
        this.multi_choice = !this.pollData.single_choice;
        let answers = [];
        for (let i = 0; i < this.pollData.data.length; i++) {
          answers.push(this.pollData.data[i].answer);
        }
        this.pollForm.answers = answers;
      }
      this.isSelectingBackground = false;
      this.postBackground = null;
      this.canShowBackgroundList = false;
      this.disableBackgroundBtn = false;
      // this.$store.commit("updateModalIsOpen", true);
    },

    beforeClosed(event) {
      // this.$store.commit("updateModalIsOpen", false);
    },

    updatePost() {
      this.show = true;
      const formData = new FormData();
      let content = this.convertUrlContent(this.html_content);
      formData.append("html_content", content);
      for (let i = 0; i < this.file_ids.length; i++) {
        formData.append("new_file_ids[]", this.file_ids[i]);
      }
      for (let i = 0; i < this.removedFileIds.length; i++) {
        formData.append("remove_file_ids[]", this.removedFileIds[i]);
      }
      let type = this.selectTypeUpload;
      if (this.selectTypeUpload && this.selectTypeUpload === POST_TYPE.IMAGE && this.medias.length > 1) {
        type = POST_TYPE.ALBUM;
      } else if (this.selectTypeUpload && this.selectTypeUpload === POST_TYPE.ALBUM && this.medias.length < 2) {
        type = POST_TYPE.IMAGE;
      }
      if (this.medias.length === 0) {
        type = POST_TYPE.TEXT;
      }
      formData.append("type", type);
      this.tagUserItems.forEach(item => {
        formData.append("tags[]", item.id);
      })

      if (this.postBackground && this.hasAllowedBackground) {
        formData.append("background", JSON.stringify({"background_url": this.postBackground.background_url, "color": this.postBackground.color}))
      } else if (this.postBackground == null) {
        formData.append("background", null);
      }

      PostService.updatePost(this.postData.id, formData).then(res => {
        this.show = false;
        if (res.status) {
          this.$store.dispatch("alerts/success", 'Bạn đã chỉnh sửa bài viết thành công.');
          this.postData.html_content = this.html_content;
          this.postData.medias = this.medias;
          this.postData.type = type;
          this.$emit('update-post', this.postData);
          this.$modal.hide('update-post-modal')
        }
      });
    },

    convertUrlContent(content) {
      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      return content.replace(urlRegex, function (url) {
        return '<a href="' + url + '">' + url + '</a>';
      });
    },

    toogleDialogEmoji() {
      this.showDialogEmoji = !this.showDialogEmoji;
    },

    onSelectEmoji(emoji) {
      this.html_content += emoji.data;
    },

    hiddenDialogEmoji() {
      this.showDialogEmoji = false
    },
    deletePoll(index) {
      this.pollForm.answers.splice(index, 1);
    },
    confirmEditingMedia(removedIdList) {
      let mediaLatest = this.medias.filter(x => {
        return !removedIdList.includes(x.id);
      });
      this.medias = mediaLatest;
      removedIdList.forEach(removedId => {
        if (!this.file_ids.includes(removedId)) {
          this.removedFileIds.push(removedId);
        }
      });
      let fileIdLatest = this.file_ids.filter(x => {
        return !removedIdList.includes(x);
      })
      this.file_ids = fileIdLatest;
      this.isEditingMedia = false;
    },
    storageListener() {
      let index = localStorage.getItem("delete_file_index");
      if (index) {
        let removedId = this.medias[index].id;
        if (this.file_ids.includes(removedId)) {
          let fileIdAfterRemoved = this.file_ids.filter(item => {
            return item != removedId;
          });
          this.file_ids = fileIdAfterRemoved;
        } else {
          this.removedFileIds.push(removedId);
        }
        this.medias.splice(index, 1);
        localStorage.removeItem("delete_file_index");
      }
    },
    selectUpload(type) {
      if (this.medias.length > 0) {
        return;
      }
      this.selectTypeUpload = type;
    },
    async onFileChange(e) {
      let selectedFiles = e.target.files;
      let files = [];
      this.files = Object.values(e.target.files);
      await this.uploadFile();
      for (let i = 0; i < selectedFiles.length; i++) {
        files.push(selectedFiles[i]);
        // if (this.selectTypeUpload == POST_TYPE.FILE) {
        let item = {
          name: selectedFiles[i].name,
          file_size: selectedFiles[i].size,
          extension: selectedFiles[i].name.split('.').pop(),
          url: null,
          path: this.file_urls[i],
          id: this.file_ids[i]
        }
        this.medias.push(item);
      }
    },

    async uploadFile() {
      this.loadingUploadFile = true;
      if (this.files.length > 0) {
        this.file_ids = [];
        this.file_urls = [];
        const formFile = new FormData();

        for (let i = 0; i < this.files.length; i++) {
          formFile.append("files[]", this.files[i]);
        }

        await PostService.uploadFile(formFile).then(res => {
          if (res.status) {
            for (let i = 0; i < res.data.length; i++) {
              this.file_ids.push(res.data[i]['file_id'])
              this.file_urls.push(res.data[i]['url']);
            }
          }
          this.loadingUploadFile = false;
        });
      }
    },
    editImageContent() {
      this.isEditingMedia = true;
    },
    changeToTagUserPopup(action) {
      if (action == 'to_tag_user') {
        this.isTagUser = true;
        $(".vue-popover").hide();
      }
    },
    handleTagUserForm(e) {
      this.tagUserItems = e;
      this.isTagUser = false;
    },
    getPostBackgroundImageList() {
      SettingService.getPostBackgroundList().then(res => {
        if (res && res.data) {
          this.postBackgroundImageList = res.data
        }
      });
    },
    selectPostBackground(e) {
      this.postBackground = e;
      this.hasAllowedBackground = true;
      this.isSelectingBackground = false;
    },
  },
}

</script>

<style lang="scss">
.md-dialog {
  .md-dialog-container {
    width: 515px !important;
  }
}

.group-section {
  padding: 0 0 15px;
}

.select-group-modal .group-info-wrapper {
  height: auto;
  padding: 0 10px;
}

.select-group-modal .bookmark {
  height: 12px !important;
}

.select-group-modal .group-text {
  background: #EDEFF5;
  padding: 4px 6px;
  width: auto;
  border-radius: 4px;
  margin-top: 4px;
}

.image-content {
  position: relative;
}

.image-content .close-image {
  position: absolute;
  top: 20px;
  right: 20px;
  opacity: 0;
  font-size: 25px;
  color: #FFFFFF;
  z-index: 2;
  cursor: pointer;
}

.image-content:hover .close-image {
  opacity: 1;
}

.cke_bottom {
  display: none !important;
}

.cke_contents {
  height: 300px !important;
}

.select-group-modal .img-emoji {
  position: absolute;
  width: 22px !important;
  cursor: pointer;
  right: 10px;
  bottom: 10px;
}

.select-group-modal .emoji {
  top: 45px;
}

.update-modal-action {

}
</style>
